import { persistableOrder } from './layer-tree';

/**
 * Per-project draw order (hooks/useMapLayers `layerOrder`), kept in localStorage as a JSON
 * array of entry keys, bottom to top. Only stable keys are written (lib/layer-tree.js
 * isStableKey): imported / result / service ids change every session.
 */
export const LAYER_ORDER_PREFIX = 'ultimate-gis:layer-order:v1:';

export const layerOrderKey = (projectId) => `${LAYER_ORDER_PREFIX}${projectId || 'default'}`;

export const isValidStoredOrder = (v) => Array.isArray(v) && v.every((k) => typeof k === 'string');

function storageOf(storage) {
  if (storage) return storage;
  try { return window.localStorage; } catch { return null; }
}

export function loadLayerOrder(projectId, storage) {
  const s = storageOf(storage);
  if (!s) return [];
  try {
    const v = JSON.parse(s.getItem(layerOrderKey(projectId)));
    return isValidStoredOrder(v) ? v : [];
  } catch { return []; }
}

export function saveLayerOrder(projectId, order, storage) {
  const s = storageOf(storage);
  if (!s) return;
  try { s.setItem(layerOrderKey(projectId), JSON.stringify(persistableOrder(order))); } catch { /* private mode / quota */ }
}
